<template>
  <MapTab key="mapTabFav" target="fav" />
</template>

<script>
import MapTab from "@/components/map/MapTab.vue";

export default {
  name: "MapTabFav",
  components: {MapTab},
};
</script>
